export default __webpack_public_path__ + "static/media/img-home6.01cad3ec.png";